import { colors } from '../../Pages/Sindico/colors';
import styled from 'styled-components';

export const StyledDropdown = styled.div`
  position: relative;
  margin-top: ${(props) => props.$marginTop ?? 0}px;
  margin-bottom: ${(props) => props.$marginBottom ?? 0}px;

  .container-dropdown-search {
    height: fit-content;

    .selected-item-dropdown-search {
      position: relative;
      width: 100%;
      button {
        padding: 0;
        display: flex;
        align-items: center;
        gap: 16px;
        border: none;
        background-color: transparent;
        font-size: 18px;
        font-weight: normal;
        line-height: 24px;
        color: ${colors.gray[700]};
        max-width: 100%;

        span {
          box-sizing: border-box;
          max-width: calc(100% - 40px);
          display: block;
          word-break: break-word;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        &:hover {
          cursor: pointer;
          opacity: 0.95;
        }

        svg {
          rotate: ${({ $rotateIconDropdown }) =>
            $rotateIconDropdown ? '180deg' : '0'};
          transition: 0.3s;
        }
      }
    }

    .content-dropdown-search {
      position: absolute;
      top: 40px;
      width: ${({ $width }) => ($width ? `${$width}px` : '100%')};

      padding: 32px;

      background-color: ${colors.white};
      border-radius: 8px;
      border: 1px solid #eee;
      overflow-y: none;
      box-sizing: border-box;
      filter: drop-shadow(0px 0px 32px rgba(0, 0, 0, 0.06));

      .search-bar-dropdown-search {
        display: flex;
        gap: 16px;
        width: 100%;
        margin-bottom: 32px;

        input {
          width: 100%;
          border: none;
          font-size: 16px;
          color: ${colors.gray[700]};

          &:focus {
            outline: none;
          }
        }
      }

      .items-list-dropdown-search {
        display: flex;
        flex-direction: column;
        gap: 16px;
        overflow-y: auto;
        max-height: ${({ $maxHeight }) => $maxHeight ?? '120'}px;
        width: 100%;
        display: grid;

        button {
          border: none;
          background-color: transparent;
          line-height: 24px;
          text-align: left;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          width: 100%;
          font-size: 16px;
          color: ${colors.gray[700]};
          font-family: inherit;

          cursor: pointer;
          &:hover {
            color: ${colors.gray[700]};
          }

          &.selected-item-dropdown-search {
            color: ${colors.gray[700]};
            cursor: default;
            font-weight: 500;
          }
        }

        .text-empty-dropdown-search {
          font-size: 16px;
          color: ${colors.gray[700]};
        }

        &::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          border-radius: 10px;
          background-color: #f5f5f5;
          opacity: 0.7;
          border-left: 16px solid transparent;
        }

        &::-webkit-scrollbar {
          width: 12px;
          background-color: #f5f5f5;
          opacity: 0.7;
          border-radius: 10px;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          background-color: rgba(0, 0, 0, 0.2);
          opacity: 0.5;
          border-left: 16px solid transparent;
        }
      }
    }

    .skeleton-drop-down {
      &:not(:last-of-type) {
        margin-bottom: 16px;
      }
    }
  }

  @media (max-width: 768px) {
    .container-dropdown-search .content-dropdown-search {
      width: 100%;
    }
    .selected-item-dropdown-search {
      button {
        font-size: 16px !important;
      }
    }
  }
`;
